import React, { PropTypes } from 'react';

// Components
import Item from '../../item/Item';

const propTypes = {
  list: PropTypes.object.isRequired,
};

const List = (props) => {
  const items = props.list.items;

  const list = items.map((item, i) => {
    const { image, alt, size, content, header, meta, description } = item;
    return (
      <Item
        key={i}
        image={image}
        alt={alt}
        size={size}
        content={content}
        header={header}
        meta={meta}
        description={description}
      />
    );
  });

  const className = `ui ${props.list.extraClasses} items`;

  return (
    <div className={className}>
      {list}
    </div>
  );
};

List.propTypes = propTypes;

export default List;



/** WEBPACK FOOTER **
 ** ./src/components/layout/sui/contents/list/List.js
 **/